<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      viewBox="0 0 24 24"
    >
      <path
        d="M21 8C21 7.44771 20.5523 7 20 7H4C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H20C20.5523 17 21 16.5523 21 16V8ZM5 14.0098V14C5 13.4477 5.44772 13 6 13C6.55228 13 7 13.4477 7 14V14.0098C7 14.5621 6.55228 15.0098 6 15.0098C5.44772 15.0098 5 14.5621 5 14.0098ZM17 14.0098V14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V14.0098C19 14.5621 18.5523 15.0098 18 15.0098C17.4477 15.0098 17 14.5621 17 14.0098ZM14 13C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H10C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13H14ZM23 16C23 17.6569 21.6569 19 20 19H4C2.34315 19 1 17.6569 1 16V8C1 6.34315 2.34315 5 4 5H20C21.6569 5 23 6.34315 23 8V16Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconApecKeyboard',
  };
  </script>
  
  <style scoped>
  .icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    fill: inherit;
    flex-shrink: 0;
  }
  </style>
  